<template>
    <div>
        <m-assembly-table
            ref='pageForm'
            columnDrag
            thDrag
            :formData='formData'
            :columns='columns'
            :data='tableData'
            :tableButtons='tableButtons'
            :loading='loading'
            :currentPage='settings.currentPage'
            :pageSize='settings.pageSize'
            :total='settings.total'
            :settings='settings'
            @onSubmit='onSubmit'
            @onPageSizeChange='onPageSizeChange'
            @onCurrentPageChange='onPageChange'
            @onSelectionChange="onSelectionChange">
        </m-assembly-table>
    </div>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table';
import moment from 'moment';
import { langParams, exportExcel } from '@/utils/tool';
import mixin from './suppliesFormOutside/index';

export default {
    name: 'suppliesFormOutside',
    components: {
        mAssemblyTable,
    },
    mixins: [mixin],
    computed: {
        getFormVals() {
            return this.getFormDataVModel(this.formData.items);
        },
    },
    data() {
        return {
            formData: {
                row: 3,
                items: [
                    {
                        title: this.$t('createDeliveryOrderByOrder.t1'), // 库存组织
                        placeholder: this.$t('supplyRatioQueryTable.organizationHolder'),
                        value: '',
                        field: 'organizationCode',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('createDeliveryOrderToInformView.t49')
                            },
                        },
                        methods: {
                            change: () => {
                                this.tableData = [];
                                this.selection = [];
                            },
                        },
                    },
                    {
                        value: moment().subtract(6, 'M').format('YYYY-MM-DD'), // 单据日期
                        field: 'creationDateBegin',
                        editable: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('suppliesFormOutside.t3'), // 单据日期不能为空
                            },
                        },
                        layout: {
                            row: 1,
                            span: 8,
                            offset: 0,
                        },
                        style: 'width:100%',
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                            needFormat: false,
                            options: {
                                // disabledDate(date) {
                                //     var dt = new Date();
                                //     dt.setMonth(dt.getMonth() - 12);
                                //     return date && date.valueOf() < dt;
                                // }
                            },
                        },
                        type: 'datePicker',
                        title: this.$t('suppliesFormOutside.t2'), // 单据日期
                        isDouble: true,
                    },
                    {
                        hide: true,
                        value: moment().format('YYYY-MM-DD'),
                        field: 'creationDateEnd',
                        editable: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('suppliesFormOutside.t3'), // 单据日期不能为空
                            },
                        },
                        style: 'width:100%',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                            needFormat: false,
                            options: {
                                // disabledDate(date) {
                                //     var dt = new Date();
                                //     dt.setMonth(dt.getMonth() - 12);
                                //     return date && date.valueOf() < dt;
                                // }
                            },
                        },
                        type: 'datePicker',
                        title: '',
                    },
                    {
                        value: '',
                        field: 'wxMode',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        methods: {
                            change() {
                            },
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('suppliesFormOutside.t1'), // 请领模式
                    },
                    {
                        value: '',
                        field: 'requestLeadCode',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('suppliesFormOutside.t4'), // 领料单号
                    },
                    {
                        value: '',
                        field: 'status',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        methods: {
                            change() {
                            },
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('suppliesFormOutside.t5'), // 单据状态
                    },
                    {
                        value: '',
                        field: 'approvalStatus',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        methods: {
                            change() {
                            },
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('suppliesFormOutside.t6'), // 审批状态
                    },
                    {
                        value: '',
                        field: 'itemCodeBegin', // 物料编码
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('DeliveryOrderQuery.t26'),
                        isDouble: true,
                    },
                    {
                        hide: true,
                        value: '',
                        title: this.$t('DeliveryOrderQuery.t27'),
                        field: 'itemCodeEnd',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                    },
                    {
                        value: '',
                        field: 'orderType',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        methods: {
                            change() {
                            },
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('purchaseDistribution.djlx'), // 单据类型
                    },
                    {
                        value: '',
                        field: 'container',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('suppliesFormOutside.t7'), // 柜号
                    },
                ],
            },
            columns: {
                columns: [
                    {
                        type: 'selection',
                        width: 35,
                        align: 'center',
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.detailBtn'), // 明细
                        width: 40,
                        align: 'center',
                        render: (h, params) => {
                            const { headerId } = params.row;
                            return h('a', {
                                on: {
                                    click: () => {
                                        this.$router.push({
                                            name: 'suppliesFormOutsideDetail',
                                            query: {
                                                headerId,
                                            },
                                        });
                                    },
                                },
                            }, this.$t('electronicContract.detail'));
                        },
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t1'), // 库存组织
                        width: 60,
                        key: 'organizationCode',
                        align: 'center',
                    },
                    {
                        title: this.$t('suppliesFormOutside.t4'), // 领料单号
                        width: 100,
                        key: 'requestLeadCode',
                        align: 'center',
                    },
                    {
                        title: this.$t('suppliesFormOutside.t7'), // 柜号
                        width: 100,
                        key: 'containers',
                        align: 'center',
                        tooltip: true,
                    },
                    {
                        title: this.$t('suppliesFormOutside.t1'), // 请领模式
                        width: 100,
                        key: 'wxMode',
                        align: 'center',
                        render: (h, params) => {
                            const { wxMode } = params.row;
                            return h('span', this.INT_REQ_MODE.find((item) => item.value == wxMode).label);
                        },
                    },
                    {
                        title: this.$t('purchaseDistribution.djlx'), // 单据类型
                        width: 100,
                        key: 'orderType',
                        align: 'center',
                        render: (h, params) => {
                            const { orderType } = params.row;
                            return h('span', this.orderType.find((item) => item.value === orderType).label);
                        },
                    },
                    {
                        title: this.$t('suppliesFormOutside.t5'), // 单据状态
                        width: 80,
                        key: 'status',
                        align: 'center',
                        render: (h, params) => {
                            const { status } = params.row;
                            return h('span', this.INT_REQ_STATUS.find((item) => item.value === status).label);
                        },
                    },
                    {
                        title: this.$t('suppliesFormOutside.t6'), // 审批状态
                        width: 80,
                        key: 'approvalStatus',
                        align: 'center',
                        render: (h, params) => {
                            const { approvalStatus } = params.row;
                            return h('span', this.INT_REQ_APPROVED_STATUS.find((item) => item.value === approvalStatus).label);
                        },
                    },
                    {
                        title: this.$t('suppliesFormOutside.t35'), // 报关状态
                        width: 80,
                        key: 'imptStatus',
                        align: 'center',
                        render: (h, params) => {
                            const { imptStatus } = params.row;
                            return h('span', this.INT_WX_IMPT_STATUS.find((item) => item.value === imptStatus).label);
                        },
                    },
                    {
                        title: this.$t('suppliesFormOutside.t8'), // 请/退领数量
                        width: 100,
                        key: 'totalQty',
                        align: 'right',
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t54'), // 打印次数
                        width: 60,
                        key: 'printTimes',
                        align: 'right',
                    },
                    {
                        title: this.$t('suppliesFormOutside.t2'), // 单据日期
                        width: 100,
                        key: 'creationDate',
                        align: 'center',
                        render: (h, params) => {
                            const { creationDate } = params.row;
                            return h('span', creationDate && creationDate.split(' ')[0] || '');
                        },
                    },
                    {
                        title: this.$t('suppliesFormOutside.t9'), // 审批流程节点
                        width: 80,
                        key: 'approval',
                        align: 'center',
                        render: (h, parmas) => {
                            const { approvalStatus, headerId, iflowStatus } = parmas.row;
                            if (approvalStatus !== 'DRAFT' && iflowStatus !== 'NO_NEED') {
                                return h('Button', {
                                    props: {
                                        icon: 'android-list',
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({
                                                name: 'suppliesFormOutsideDetail',
                                                query: {
                                                    headerId,
                                                    businessId: headerId,
                                                    source: 'gsc',
                                                },
                                            });
                                        },
                                    },
                                });
                            }
                        },
                    },
                    {
                        title: this.$t('createMaterialLabel.print'), // 打印
                        width: 80,
                        key: '',
                        align: 'center',
                        render: (h, parmas) => {
                            let loading = false;
                            return h('Button', {
                                props: {
                                    icon: 'printer',
                                },
                                on: {
                                    click: async () => {
                                        if (loading) return;
                                        loading = true;
                                        await this.getPrintData([parmas.row]);
                                        loading = false;
                                    },
                                },
                            });
                        },
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t28'), // 创建人
                        width: 100,
                        key: 'createdBy',
                        align: 'center',
                    },
                    {
                        title: this.$t('UIDLabelPrint.t27'), // 供应商编码
                        width: 100,
                        key: 'vendorCode',
                        align: 'center',
                    },
                    {
                        title: this.$t('importNoticeCommon.t26'), // 供应商名称
                        width: 100,
                        key: 'vendorName',
                        align: 'center',
                        tooltip: true,
                    },
                    {
                        title: this.$t('common.operation'), // 操作
                        key: 'opt',
                        align: 'center',
                        minWidth: 90,
                        fixed: 'right',
                        render: (h, params) => {
                            const { approvalStatus, iflowStatus, headerId, status } = params.row;
                            const isEdit = ['REJECED', 'DRAFT'].includes(approvalStatus) && status === '1';
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                    },
                                    on: {
                                        click: () => {
                                            let pars = {};
                                            if (['DRAFT', 'REJECED'].includes(approvalStatus) && iflowStatus === 'ON_THE_WAY') {
                                                pars = {
                                                    reject: 1,
                                                    businessId: headerId,
                                                    source: 'gsc',
                                                };
                                            }
                                            this.$router.push({
                                                name: isEdit ? 'suppliesFormOutsideEdit' : 'suppliesFormOutsideDetail',
                                                query: {
                                                    headerId,
                                                    ...pars,
                                                },
                                            });
                                        },
                                    },
                                }, this.$t(isEdit ? 'importNoticeCommon.t12' : 'importNoticeCommon.t15')), // 修改、查看
                                h('a', {
                                    on: {
                                        click: () => {
                                            this.discard(headerId);
                                        },
                                    },
                                    style: {
                                        display: isEdit ? 'inline' : 'none',
                                    },
                                }, this.$t('importNoticeCommon.t13')), // 作废
                            ]);
                        },
                    },
                ],
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('suppliesFormOutside.t10'), // 新增请领单
                        type: 'primary',
                        icon: 'archive',
                        size: 'small',
                        click: () => {
                            this.$router.push({
                                name: 'suppliesFormOutsideAdd',
                            });
                        },
                    },
                    // {
                    //     label: this.$t('suppliesFormOutside.t11'), // BOM查询
                    //     type: 'primary',
                    //     icon: 'archive',
                    //     size: 'small',
                    //     click: () => {
                    //     },
                    // },
                    {
                        label: this.$t('createMaterialLabel.print'), // 打印
                        type: 'primary',
                        icon: 'archive',
                        size: 'small',
                        disabled: () => this.selection.length === 0,
                        click: async (button) => {
                            button.loading = true;
                            await this.getPrintData(this.selection);
                            button.loading = false;
                        },
                    },
                    {
                        label: this.$t('common.export'), // 导出
                        type: 'primary',
                        icon: 'archive',
                        size: 'small',
                        click: (button) => {
                            if (this.$refs.pageForm.validateForm()) {
                                this.$set(button, 'loading', true);
                                exportExcel('/gscint/req/export', {
                                    ...this.getFormVals,
                                    vendorCode: this.vendorCode,
                                    language: langParams(this.$i18n.locale),
                                }, `${this.$t('route.suppliesFormOutside')}${moment().format('YYYY-MM-DD')}.xlsx`, this)
                                    .finally(() => {
                                        this.$set(button, 'loading', false);
                                    });
                            }
                        },
                    },
                ],
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
                submitLoading: false,
            },
            selection: [],
            INT_REQ_MODE: [],
            INT_REQ_STATUS: [],
            INT_REQ_APPROVED_STATUS: [],
            INT_WXQL_MANUALLY_ADD_PO: [],
        };
    },
    methods: {
        onSubmit(currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageSizeChange(currentPage, pageSize) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        onSelectionChange(selection) {
            this.selection = selection;
        },
        onSearch() {
            this.loading = true;
            this.postApi('/gscint/req/queryHeaderPage', {
                ...this.getFormVals,
                vendorCode: this.vendorCode,
                pageIndex: this.settings.currentPage,
                pageSize: this.settings.pageSize,
                language: langParams(this.$i18n.locale),
            }, (data) => {
                const { list, total } = data;
                this.tableData = list;
                this.settings.total = total;
                this.selection = [];
            })
                .finally(() => {
                    this.loading = false;
                });
        },
        /* 作废 */
        discard(headerId) {
            this.$Modal.confirm({
                content: this.$t('importNoticeCommon.t23'), // 确定要作废吗？
                onOk: () => {
                    setTimeout(() => {
                        this.loading = true;
                        this.getApi('/gscint/req/discard', {
                            headerId,
                        }, () => {
                            this.$Modal.success({
                                content: this.$t('index.common.delete_success'), // 删除成功
                            });
                            this.onSearch();
                        })
                            .finally(() => {
                                this.loading = false;
                            });
                    }, 400);
                },
            });
        },
        /* 获取打印数据 */
        getPrintData(data) {
            const headerIds = data.map((item) => item.headerId).join();
            return this.getApi('/gscint/req/getPrintData', {
                headerIds,
                language: langParams(this.$i18n.locale),
            }, (reportlets) => {
                reportlets = reportlets.map(({ header, lineList }) => {
                    return {
                        ...header,
                        lineList,
                    };
                });
                const directs = reportlets.filter((item) => item.wxMode === 'DIRECT_DELIVERY_TO_SUPPLIER');
                const factorys = reportlets.filter((item) => item.wxMode !== 'DIRECT_DELIVERY_TO_SUPPLIER');
                if (directs.length > 0) {
                    this.cloudPrint('hw-wx-request-lead', { reportlets: directs });
                }
                if (factorys.length > 0) {
                    this.cloudPrint('hw-wx-request-lead-factory', { reportlets: factorys });
                }
            });
        },
    },
    activated() {
        const { pageForm } = this.$refs;
        if (!this.getFormVals.organizationCode) return;
        if (!pageForm.validateForm()) return;
        pageForm.onSubmit();
    },
};
</script>
